<button (click)="clearFilters()" [disabled]="!isAnyFilterActive()" class="clear-filters-button" id="clear-filters-button"> {{ buttonText }}</button>
